export default {
	errors: {
		marked: 'Mark as delivered failed',
		unmarked: 'Unmark as delivered failed',
	},
	success: {
		marked: 'Marked as delivered',
		unmarked: 'Unmarked as delivered',
	},
	undo: {
		action: 'Action has been undone',
		label: 'Undo',
	},
};
